import * as React from 'react'
import styled, { withTheme } from 'styled-components'
import { IconAttention, IconCheck, IconInfoCircle } from '@loadsmart/icons'
import { Theme } from 'styles/theme'

export type AlertTypes = 'success' | 'error' | 'info'

function getTypeBackground(type: AlertTypes, theme: Theme) {
  switch (type) {
    case 'success':
      return theme.colors.backgroundSuccess
    case 'error':
      return theme.colors.backgroundError
    case 'info':
      return theme.colors.backgroundInfo
  }
}

function getTypeIconColor(type: AlertTypes, theme: Theme) {
  switch (type) {
    case 'success':
      return theme.colors.textSuccess
    case 'error':
      return theme.colors.textError
    case 'info':
      return theme.colors.textInfo
  }
}

function getTypeIcon(type: AlertTypes) {
  switch (type) {
    case 'success':
      return IconCheck
    case 'error':
      return IconAttention
    case 'info':
      return IconInfoCircle
  }
}

export const Wrapper = styled.div<{ type: AlertTypes }>`
  align-items: center;
  background-color: ${({ theme, type }) => getTypeBackground(type, theme)};
  color: ${({ theme }) => theme.colors.backgroundSecondary};
  display: flex;
  font-size: 14px;
  line-height: 18px;
  padding: 11px;
  margin: -10px 0 15px 0;

  svg {
    display: inline-block;
    margin-right: 13px;
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  theme: Theme
  type: AlertTypes
}

function Alert({ children, theme, type, ...rest }: Props) {
  const Icon = getTypeIcon(type)
  return (
    <Wrapper {...rest} type={type}>
      <Icon width={23} height={23} fill={getTypeIconColor(type, theme)} />
      {children}
    </Wrapper>
  )
}

export default withTheme(Alert)
